import _default from './Comment';
export { _default as default };